/* Way B store: product page. Fills the template from the catalog (?h=handle, default the home product),
   then wires the colour buttons, add to cart, the add-on offer and the sticky bar. Runs before store.js. */
(function () {
  'use strict';
  var C = window.CATALOG, L = window.LISTS;
  // the Shopify theme sets STORE_CFG (asset folder, shop base path, collection url) and STORE_T (words in the visitor's language)
  var CFG = window.STORE_CFG || {}, TT = window.STORE_T || {}, SHOP = window.SHOP || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var A = function (s) { return CFG.asset ? CFG.asset + s.replace(/\//g, '-') : '../assets/' + s; };
  var t = function (k, d) { return TT[k] || d; };
  var purl = function (x) {
    if (!CFG.shopify) return 'product.html?h=' + x;
    var sp = C[x] && SHOP[C[x].id]; return sp ? CFG.base + 'products/' + sp.h : CFG.coll;
  };
  var money = function (n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  // which piece: the Shopify product on this page (by id), or ?h=handle on the mock; the home product otherwise
  var q = new URLSearchParams(location.search).get('h');
  if (window.PRODUCT_ID) q = Object.keys(C).filter(function (k) { return C[k].id === window.PRODUCT_ID; })[0] || q;
  var h = q && C[q] ? q : window.HOME_PRODUCT, p = C[h];
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem('st-' + k)); sessionStorage.setItem('st-' + k, JSON.stringify(v)); } catch (e) { return null; } }

  document.title = p.t + (window.BRAND && !BRAND.slot ? ' – ' + BRAND.name : '');
  if (CFG.shopify && SHOP[p.id]) { var sp = SHOP[p.id]; p.p = money(sp.p / 100); p.c = sp.c > sp.p ? money(sp.c / 100) : null; }   // live Shopify price
  $$('[data-p="title"]').forEach(function (e) { e.textContent = p.t; });
  $$('[data-p="price"]').forEach(function (e) { e.textContent = p.p; });
  $$('[data-p="compare"]').forEach(function (e) { e.textContent = p.c || ''; e.hidden = !p.c; });
  var amt = function (s) { return parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0; }, off = p.c ? Math.round((1 - amt(p.p) / amt(p.c)) * 100) : 0;
  $$('[data-p="save"]').forEach(function (e) { e.textContent = off ? t('save', 'Save') + ' ' + off + '%' : ''; e.hidden = !off; });
  $$('[data-p="thumb"]').forEach(function (e) { e.src = A(p.img[0]); });
  // colour buttons: each colour has its own photo (p.vi = gallery index per colour); the picked colour goes into the bag
  var vr = $('[data-p="variant"]'), colour = p.v ? p.v[1][0] : '';
  if (vr) {
    if (p.v) {
      $('[data-p="vname"]', vr).textContent = p.v[0];
      $('[data-p="vval"]', vr).textContent = colour;
      var sw = $('[data-p="swatches"]', vr);
      if (sw) {
        sw.innerHTML = p.v[1].map(function (c, i) { return '<button type="button" class="sw-b' + (i ? '' : ' on') + '" data-sw="' + i + '" aria-pressed="' + (i ? 'false' : 'true') + '"><i style="background:' + (window.SWATCH && SWATCH[c] || '#999') + '"></i>' + esc(c) + '</button>'; }).join('');
        $$('[data-sw]', sw).forEach(function (b) {
          b.addEventListener('click', function () {
            var i = +b.getAttribute('data-sw'); colour = p.v[1][i];
            $('[data-p="vval"]', vr).textContent = colour;
            $$('[data-sw]', sw).forEach(function (o) { o.classList.toggle('on', o === b); o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
            var th = $$('[data-thumbs] button')[p.vi ? p.vi[i] : 0]; if (th) th.click();
          });
        });
      }
    } else vr.hidden = true;
  }
  var tl = $('[data-toggle-list]'); if (tl) tl.setAttribute('data-exclude', h);   // the add-to-order switches never offer this product again
  var desc = $('[data-p="desc"]');
  if (desc) desc.innerHTML = p.d.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('');


  // gallery: every image, plus thumbnails
  var gal = $('[data-gallery]'), th = $('[data-thumbs]');
  if (gal) gal.innerHTML = p.img.map(function (s, i) { return '<figure class="gi"><img src="' + A(s) + '" alt="' + esc(p.t) + (i ? ' – ' + t('image', 'image') + ' ' + (i + 1) : '') + '"' + (i > 1 ? ' loading="lazy"' : '') + '></figure>'; }).join('');
  if (th) {
    th.innerHTML = p.img.map(function (s, i) { return '<button type="button" class="' + (i ? '' : 'on') + '" aria-label="' + t('showImage', 'Show image') + ' ' + (i + 1) + '"><img src="' + A(s) + '" alt=""></button>'; }).join('');
    $$('button', th).forEach(function (b, i) {
      b.addEventListener('click', function () {
        var fig = gal.children[i];
        if (getComputedStyle(gal).overflowX === 'auto' || getComputedStyle(gal).overflowX === 'scroll') gal.scrollTo({ left: fig.offsetLeft - gal.children[0].offsetLeft, behavior: 'smooth' });
        else { $$('.gi', gal).forEach(function (f, k) { f.classList.toggle('on', k === i); }); }
        $$('button', th).forEach(function (o, k) { o.classList.toggle('on', k === i); });
      });
    });
    gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
      $$('button', th).forEach(function (o, k) { o.classList.toggle('on', k === i); });
      var n = $('[data-gal-n]'); if (n) n.textContent = (i + 1) + ' / ' + p.img.length;
      var b = $$('button', th)[i];
      if (b && th.scrollWidth > th.clientWidth + 2) th.scrollTo({ left: b.offsetLeft - th.offsetLeft - (th.clientWidth - b.clientWidth) / 2, behavior: 'smooth' });
    }, { passive: true });
    var first = $('.gi', gal); if (first) first.classList.add('on');
    var n = $('[data-gal-n]'); if (n) n.textContent = '1 / ' + p.img.length;
  }

  // customer videos in the buy box: play muted while in view, tap one for sound
  var cvs = $$('.cv');
  var play = function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); };
  if (cvs.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = $('video', e.target); if (e.intersectionRatio >= 0.6) play(v); else v.pause(); });
    }, { threshold: [0, 0.6] });
    cvs.forEach(function (c) { io.observe(c); });
  }
  cvs.forEach(function (c) {
    var v = $('video', c);
    $('button', c).addEventListener('click', function () {
      var on = !c.classList.contains('on');
      cvs.forEach(function (o) { if (o !== c) { o.classList.remove('on'); $('video', o).muted = true; } });
      c.classList.toggle('on', on); v.muted = !on;
      if (on) v.currentTime = 0;
      play(v);
    });
  });

  // "Buy more, Save more": one horizontal rail of cards (swipe or arrows)
  var bm = $('[data-buymore]');
  if (bm) {
    bm.innerHTML = L.upsell.filter(function (x) { return x !== h; }).map(function (x) {
      var c = C[x]; return '<div class="bm-row"><a href="' + purl(x) + '"><img src="' + A(c.img[0]) + '" alt="" loading="lazy"></a><div class="bm-info"><a href="' + purl(x) + '">' + esc(c.t) + '</a><span><b>' + c.p + '</b>' + (c.c ? ' <s>' + c.c + '</s>' : '') + '</span></div><button type="button" data-add="' + x + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' + t('add', 'Add') + '</button></div>';
    }).join('');
  }

  // stock left, and the ship date: two business days from today
  var left = 2 + Math.floor(Math.random() * 5);
  $$('[data-stock-n]').forEach(function (e) { e.textContent = left; });
  var ship = new Date(), days = 2;
  while (days) { ship.setDate(ship.getDate() + 1); if (ship.getDay() % 6) days--; }
  $$('[data-ship]').forEach(function (e) { e.textContent = ship.toLocaleDateString(t('dateLocale', 'en-US'), { weekday: 'long', month: 'long', day: 'numeric' }); });

  // add to cart, then the one-time add-on offer, then the cart
  function atc() {
    window.STORE.add(h, 1, colour);
    if (!store('offer-seen')) { store('offer-seen', 1); openOffer(); } else window.STORE.open('cart');
  }
  $$('[data-atc]').forEach(function (b) { b.addEventListener('click', atc); });

  var offerEnd = 0, offerTimer = null;
  function openOffer() {
    window.STORE.open('offer');
    offerEnd = Date.now() + 10 * 60 * 1000;
    clearInterval(offerTimer);
    offerTimer = setInterval(function () {
      var s = Math.max(0, Math.round((offerEnd - Date.now()) / 1000));
      var t = $('[data-offer-t]'); if (t) t.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    }, 250);
  }
  var offer = $('#offer');
  if (offer) {
    $$('[data-offer-img]', offer).forEach(function (b) {
      b.addEventListener('click', function () { $('[data-offer-main]', offer).src = b.querySelector('img').src; $$('[data-offer-img]', offer).forEach(function (o) { o.classList.toggle('on', o === b); }); });
    });
    $$('[data-offer-step]', offer).forEach(function (b) {
      b.addEventListener('click', function () {
        var all = $$('[data-offer-img]', offer), i = all.findIndex(function (o) { return o.classList.contains('on'); });
        all[(i + +b.getAttribute('data-offer-step') + all.length) % all.length].click();
      });
    });
    function done(take) {
      if (take) window.STORE.add('care-brush-offer', 1);
      offer.classList.remove('open'); clearInterval(offerTimer);
      setTimeout(function () { offer.hidden = true; window.STORE.open('cart'); }, 220);
    }
    $('[data-offer-yes]', offer).addEventListener('click', function () { done(true); });
    $$('[data-offer-no]', offer).forEach(function (b) { b.addEventListener('click', function () { done(false); }); });
  }

  // sticky add-to-cart bar once the main button scrolls away
  var main = $('[data-atc-main]'), bar = $('[data-sticky]');
  if (main && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(main);
  }
})();
